import React from 'react';
import Login from './buttons/Login'
import Cart from './buttons/CartBtn'
import Signup from './buttons/Signup'
import { NavLink } from 'react-router-dom'

import { useSelector } from 'react-redux';




const Navbar = () => {
    const state = useSelector((state => state.addItem)
    )
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light py-3 bg-white shadow-sm ">
                <div className="container">
                    <NavLink to="#" className="title--navbar navbar-brand   fab fa-korvue">ARMITE SHOP</NavLink>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <NavLink className="nav-link active" aria-current="page" to="/">Home</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/products">Products</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink className="nav-link" to="/AboutDev">About Dev</NavLink>
                            </li>


                        </ul>
                        <Login />
                        <Signup />
                        <Cart />


                    </div>
                </div>
            </nav >
        </>
    );
}





export default Navbar;
